import * as yup from 'yup';

export interface IMyProfile {
	email: string;
	phoneNumber: string;
}

export const myProfileInitialValues: IMyProfile = {
	email: '',
	phoneNumber: '',
};

export const myProfileSchema = yup.object().shape({
	email: yup.string().email().required('required'),
	phoneNumber: yup
		.string()
		.min(7, 'phoneMustBe7')
		.max(7, 'phoneMustBe7')
		.matches(/^[6-8][0-9]*$/, 'myShipments:page-settings.phone-gsm-format')
		.required('required'),
});
